<template>
<div class="page-content"  data-test-key="manage-email-subscription-page">
  <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
      <div class="container mx-auto">
          <div class="grid">
              <div class="col-span-12">
                  <div class="text-center text-white">
                      <h1 class="mb-4 text-[26px]">Email subscription</h1>
                      <div class="page-next">
                        <p>Be the first to hear about new positions as soon as they’re posted so you never miss an opportunity.
                        <br/>
                        We believe you should be the first to know about job openings that match your skills and interests.</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
      <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
    </section>

  <!-- Start grid -->
  <section class="py-12">
    <div class="container mx-auto  text-center">

    <h3 class="mb-0 dark:text-white">Manage Email Subscription</h3>

    <FeedbackNotification v-if="this.notification.text != ''" 
      :feedbackText="this.notification.text" 
      :feedbackLevel="this.notification.level"/>  

    <div v-if="pageLoading" style="margin-bottom: 300px;">
      <Loader />
    </div>
    <div v-else >      

      <p class="dark:text-gray-300"><i>We'll package all searches into one email with the most relevent jobs to you..</i></p>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg" v-bind:key="emailSubscriptionByFrequency" 
              v-for="emailSubscriptionByFrequency in emailSubscriptionsResults" >

          <h4 class="mt-10 mb-5 dark:text-gray-300">Sent {{ emailSubscriptionByFrequency.Frequency }}</h4>

          <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead class="text-xs text-gray-700 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                      <th scope="col" class="px-6 py-3">
                        <i class="uil uil-tag"></i> Skills 
                      </th>
                      <th scope="col" class="px-6 py-3">
                          Working style
                      </th>
                      <th scope="col" class="px-6 py-3">
                          Contract
                      </th>
                      <th scope="col" class="px-6 py-3">
                          Company
                      </th>
                      <th scope="col" class="px-6 py-3">
                          Active
                      </th>
                      <th scope="col" class="px-6 py-3">
                          Action
                      </th>
                  </tr>
              </thead>
              <tbody>
                  <tr class="odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700 border-gray-200"
                      v-bind:key="emailSubscription.Identifier" v-for="emailSubscription in emailSubscriptionByFrequency.EmailSubscriptions">
                      <th style="max-width: 300px;" scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white" 
                        v-if="emailSubscription.EmailSearchSubscription.CategoryNames != null || 
                              emailSubscription.EmailSearchSubscription.CategoryNames != [] || 
                              !Array.isArray(emailSubscription.EmailSearchSubscription.CategoryNames)">
                          <ul class="flex flex-wrap gap-2 text-gray-700 dark:text-gray-50">
                              <li style="display:inline-block;" v-bind:key="skill"  v-for="skill in emailSubscription.EmailSearchSubscription.CategoryNames">
                                <span class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50">
                                  <a>{{ skill }}</a>
                                </span>
                              </li>                                        
                          </ul>  
                      </th>
                      <th v-else style="max-width: 300px;" scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white" >
                          ---
                      </th>
                      <td class="px-6 py-4" v-if="emailSubscription.EmailSearchSubscription.AttendanceRequirement">
                          {{ emailSubscription.EmailSearchSubscription.AttendanceRequirement }}
                      </td>
                      <td v-else class="px-6 py-4">
                          ---
                      </td>
                      <td class="px-6 py-4"  v-if="emailSubscription.EmailSearchSubscription.ContractType">
                          {{ emailSubscription.EmailSearchSubscription.ContractType }}
                      </td>
                      <td v-else class="px-6 py-4">
                          ---
                      </td>
                      <td class="px-6 py-4"  v-if="emailSubscription.EmailSearchSubscription.CompanyName">
                          {{ emailSubscription.EmailSearchSubscription.CompanyName }}
                      </td>
                      <td v-else class="px-6 py-4">
                          ---
                      </td>
                      <td class="px-6 py-4">
                          <input v-on:click="handleSetEmailSubscriptionActiveStatusClick(emailSubscription.Identifier)" v-model="emailSubscription.IsActive" type="checkbox" id="checkbox">
                      </td>
                      <td class="px-6 py-4">
                          <button 
                          class="text-gray-500 border-transparent btn bg-violet-500/20 hover:bg-gray-500 hover:text-white hover:ring hover:ring-gray-500/30" 
                          v-on:click="handleRemoveEmailSubscriptionClick(emailSubscription.Identifier)">remove</button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
    </div>
  </div>
</section>
</div>
</template>

<script>
import { emailSubscriptionAPI } from "@/api/emailSubscription";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import Loader from "@/components/Loader.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

export default {
  components: { FeedbackNotification, Loader },
  data() {
    return {
      emailSubscriptionsResults : [],
      pageLoading : true,      
      notification : {
        text : "",
        level : "",
      },
    };
  },
 created() {
    this.getEmailSubscriptionsResult()
 },
  mounted() {
    document.title = 'Email Subscription - TheJobTap.com';
  },
  methods: {
    async getEmailSubscriptionsResult() {
      this.pageLoading = true;
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await emailSubscriptionAPI.get(this.$route.params.groupidentifier);
          this.emailSubscriptionsResults = result;
        })
      );
      this.pageLoading = false;
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }    
    },
    async handleRemoveEmailSubscriptionClick(identifier) {
      this.pageLoading = true;
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await emailSubscriptionAPI.remove(identifier);
          this.getEmailSubscriptionsResult()        
        })
      );
      this.pageLoading = false;
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };           
      }    
    },
    async handleSetEmailSubscriptionActiveStatusClick(identifier) {
      this.pageLoading = true;
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await emailSubscriptionAPI.setActiveStatus(identifier);
          this.getEmailSubscriptionsResult()
        })
      );
      this.pageLoading = false;
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }    
    },
  },
};
</script>